import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import dayjs from 'dayjs'
import { formatNumber, formatPercent, formatUSD } from './format-utils'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function fuzzyFilter(filterValue, value) {
  const searchWords = filterValue.toLowerCase().split(' ')
  const itemValue = value.toLowerCase()

  return searchWords.every((word) => itemValue.includes(word))
}

export const exportToCsv = (data, filename, headers) => {
  if (!data || data.length === 0) {
    console.warn('No data to export.')
    return
  }

  // Assume data is already processed and flattened with correct headers
  const headerList = headers?.length ? headers : Object.keys(data[0])
  const csvRows = []
  csvRows.push(headerList.join(','))

  for (const row of data) {
    const values = headerList.map((header) => {
      const value = row[header]
      if (value === null || value === undefined) {
        return ''
      }
      if (typeof value === 'number') {
        return value
      }
      if (typeof value === 'boolean') {
        return value ? 'true' : 'false'
      }
      const stringValue = String(value)
      if (stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`
      }
      if (stringValue.includes(',') || stringValue.includes('\n')) {
        return `"${stringValue}"`
      }
      return stringValue
    })
    csvRows.push(values.join(','))
  }

  const csvString = csvRows.join('\n')
  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
